import React from 'react';
import {
    Modal,
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
} from 'react-native';
import {SCREEN_WIDTH} from "../../../Config/Constants";
import {BORDER_COLOR, HEADER_TITLE_COLOR, PRIMARY_BACKGROUND_COLOR} from "../../../Config/Colors";

/**
 * Confirmation Modal Props.
 */
interface ConfirmationModalProps
{
    /**
     * Flag to toggle the modal.
     */
    show?: boolean;

    /**
     * The message to display.
     */
    message?: string;

    /**
     * Callback when the proceed button was pressed.
     */
    onProceedSelected?: () => void;

    /**
     * Callback when the cancel button was pressed.
     */
    onCancelSelected?: () => void;
}

/**
 * Renders the Confirmation Modal.
 */
export default function ConfirmationModal({
    show,
    message = "Are you sure you want to perform this action?",
    onProceedSelected,
    onCancelSelected,
}: ConfirmationModalProps): JSX.Element
{
    return (
        <Modal
            animationType="fade"
            visible={show}
            transparent
            statusBarTranslucent
        >
            <View style={styles.modal}>
                <View style={styles.modalContentParent}>
                    <View style={styles.sectionTitleView}>
                        <Text style={styles.titleText}>
                            {message}
                        </Text>
                    </View>

                    <View style={styles.closeButtonView}>
                        <TouchableOpacity
                            onPress={onCancelSelected}
                            style={styles.closeButton}
                        >
                            <Text style={styles.closeButtonText}>
                                Cancel
                            </Text>
                        </TouchableOpacity>

                        <TouchableOpacity
                            onPress={onProceedSelected}
                            style={styles.closeButton}
                        >
                            <Text style={styles.closeButtonText}>
                                Proceed
                            </Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styles = StyleSheet.create({
    modal: {
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
    modalContentParent: {
        width: '40%',
        height: '30%',
        backgroundColor: PRIMARY_BACKGROUND_COLOR,
        borderWidth: 2,
        borderColor: BORDER_COLOR,
        borderRadius: SCREEN_WIDTH * 0.01,
    },
    sectionTitleView: {
        flex: 1,
        justifyContent: 'center',
        borderBottomWidth: 2,
        borderBottomColor: BORDER_COLOR,
    },
    titleText: {
        color: HEADER_TITLE_COLOR,
        fontSize: SCREEN_WIDTH * 0.015,
        fontWeight: "600",
        textAlign: 'center',
        width: '80%',
        alignSelf: 'center',
        justifyContent: 'center',
    },
    closeButtonView: {
        flexDirection: 'row',
        flex: 0.3,
        justifyContent: 'space-around',
        alignItems: 'flex-end',
    },
    closeButton: {
        width: '40%',
        alignSelf: 'center',
        height: '60%',
        borderRadius: SCREEN_WIDTH * 0.005,
        backgroundColor: HEADER_TITLE_COLOR,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
    },
    closeButtonText: {
        textAlign: 'center',
        alignSelf: 'center',
        fontSize: SCREEN_WIDTH * 0.014,
        color: PRIMARY_BACKGROUND_COLOR,
        fontWeight: '600',
    },
});
